module.exports = __webpack_public_path__ + "img/06-osm-emissao-menu.300f8e63.png";